let defaultReport = {
    id: null,
    agent_id: null,
    report_date: null,
    status: 'draft',
    approval_followup: null,
    version: 1,
    parent_id: null,
    created_at: null,
    updated_at: null,
    
    // Дані агента
    agent: null,
    
    // Коментарі до звіту
    comments: [],
    
    // Таб "Сьогодні" - денні дані, які показуються у звіті
    today: {},
    
    // Таб "Власники" - зведення
    owner_meetings_summary: {
        meetings_count: 0,
        owner_calls_total: 0,
        owner_calls_successful: 0
    },
    
    // Таб "Власники" - список зустрічей
    owner_meetings: [],
    
    // Таб "Покази" - зведення
    showings_summary: {
        showings_count: 0,
        clients_count: 0
    },
    
    // Таб "Покази" - список показів
    showings: [],
    
    // Таб "Покупці в роботі" - список покупців
    buyers: [],
    
    // Таб "Ексклюзиви" - список ексклюзивів
    exclusives: [],
    
    // Таб "Завдатки" - список завдатків
    deposits: [],
    
    // Таб "Оголошення" - дані оголошень
    ads: {
        total: 0,
        olx_count: 0,
        dimria_count: 0,
        facebook_count: 0,
        other_count: 0,
        note: ''
    },
    
    // Таб "Дзвінки" - агрегати та список
    calls_summary: {
        incoming: 0,
        outgoing: 0,
        missed: 0,
        handled_missed: 0,
    },
    calls: [],
    
    // Таб "Месенджери" - дані месенджерів
    messengers: {
        buyers_count: 0,
        objects_total: 0,
        viber_count: 0,
        telegram_count: 0,
        whatsapp_count: 0,
        note: ''
    },
    
    // Таб "План на завтра" - список завдань
    planned_tasks: [],
    
    // Таб "Самооцінка" - оцінка стажера
    self_assessment: {
        score: null,
        reason: ''
    },
    
    // Таб "Комунікація зі старшим" - оцінка комунікації
    senior_communication: {
        score: null,
        note: ''
    }
};

// Шаблон для нової зустрічі з власником
export const defaultOwnerMeeting = {
    purpose: 'presentation',
    exclusive_signed: false,
    meeting_result_id: null,
    locality_id: null,
    city_name: '',
    street_id: null,
    street_name: '',
    house_number: '',
    apartment_number: '',
    note: ''
};

// Шаблон для нового показу
export const defaultShowing = {
    client_id: null,
    object_type: 'apartment',
    locality_id: null,
    city_name: '',
    street_id: null,
    street_name: '',
    house_number: '',
    apartment_number: '',
    is_interested: false,
    has_view_agreement: false,
    agreement_no: '',
    note: ''
};

// Шаблон для нового покупця
export const defaultBuyer = {
    client_id: null,
    short_note: '',
    is_real: false,
    is_active: false,
    is_new: false
};

// Шаблон для нового ексклюзиву
export const defaultExclusive = {
    object_type: 'apartment',
    locality_id: null,
    city_name: '',
    street_id: null,
    street_name: '',
    house_number: '',
    apartment_number: '',
    note: ''
};

// Шаблон для нового завдатку
export const defaultDeposit = {
    client_id: null,
    locality_id: null,
    city_name: '',
    street_id: null,
    street_name: '',
    house_number: '',
    apartment_number: '',
    amount: null,
    currency: null,
    commission_amount: null,
    commission_payment_status: null,
    commission_paid_amount: null,
    note: ''
};

export const depositCommissionPaymentStatuses = [
    { value: 'paid_at_deposit', text: 'Сплатив при завдатку' },
    { value: 'pays_at_notary', text: 'Оплачує в нотаріуса' },
    { value: 'partially_paid', text: 'Сплатив частину' },
];

// Доступні статуси звітів
export const reportStatuses = {
    'draft': 'Чернетка',
    'submitted': 'Поданий',
    'returned': 'Повернутий',
    'approved': 'Затверджений'
};

export const APPROVAL_FOLLOWUP = {
    AWAITING_REPLY: 'awaiting_reply',
    AWAITING_ACK: 'awaiting_ack',
    DONE: 'done',
};

export function getApprovalFollowupLabel(followup, { isTrainee = false } = {}) {
    if (followup === APPROVAL_FOLLOWUP.AWAITING_REPLY) {
        return isTrainee ? 'Є коментар' : 'Очікує відповідь';
    }
    if (followup === APPROVAL_FOLLOWUP.AWAITING_ACK && !isTrainee) {
        return 'Є відповідь';
    }
    return null;
}

export function getApprovalFollowupColor(followup) {
    if (followup === APPROVAL_FOLLOWUP.AWAITING_REPLY) {
        return 'orange';
    }
    if (followup === APPROVAL_FOLLOWUP.AWAITING_ACK) {
        return 'blue';
    }
    return 'grey';
}

// Доступні мети зустрічей
export const meetingPurposes = {
    'presentation': 'Презентація послуги (стратегія продажу)',
    'exclusive': 'Підписання ексклюзиву'
};

// Доступні типи об'єктів (відповідно до бекенду)
export const objectTypes = {
    'apartment': 'Квартира',
    'house': 'Будинок',
    'cottage': 'Котедж',
    'dacha': 'Дача',
    'room': 'Кімната',
    'land': 'Ділянка',
    'commercial': 'Комерція'
};

// Шаблон для нового запланованого завдання
export const defaultPlannedTask = {
    type: 'meeting',
    description: '',
    planned_at: null,
    client_or_object: ''
};

// Доступні типи завдань
export const taskTypes = {
    'meeting': 'Зустріч',
    'showing': 'Показ',
    'call': 'Дзвінок',
    'deposit': 'Завдаток',
    'other': 'Інше'
};

export function formatReportPageTitle(baseTitle, report) {
    const agentName = report && report.agent && report.agent.name;
    return agentName ? `${baseTitle}. ${agentName}` : baseTitle;
}

export const REPORT_ACTION_EVENT_TYPES = [
    3,  // не поданий звіт
    4,  // поданий — треба перевірити
    5,  // повторно поданий — треба перевірити
    6,  // повернутий на доопрацювання
    14, // питання до звіту
    15, // затверджено з коментарем — треба відповісти
    16, // відповідь на коментар — треба підтвердити
];

export function shouldOpenReportQuestionsTab(report, { roleName } = {}) {
    if (!report || !report.id) {
        return false;
    }

    if (report.status === 'returned') {
        return true;
    }

    return report.status === 'approved'
        && report.approval_followup === 'awaiting_reply'
        && roleName === 'Trainee';
}

export default defaultReport;
